import React from "react";

export const VIEW_OVERVIEW = "overview";
export const VIEW_BUDGET = "budget";
export const VIEW_REVENUE = "revenue";

const TABS = [
  { id: VIEW_OVERVIEW, label: "Overview", icon: "ri-dashboard-line" },
  { id: VIEW_BUDGET, label: "Budget", icon: "ri-wallet-3-line" },
  { id: VIEW_REVENUE, label: "Revenue", icon: "ri-line-chart-line" },
];

const ViewTabs = ({ view, onChange }) => (
  <div
    style={{
      display: "inline-flex",
      background: "#f1f5f9",
      padding: 4,
      borderRadius: 10,
      gap: 4,
      marginBottom: 24,
    }}
  >
    {TABS.map((t) => {
      const active = view === t.id;
      return (
        <button
          key={t.id}
          type="button"
          onClick={() => onChange(t.id)}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            padding: "8px 18px",
            borderRadius: 7,
            border: "none",
            background: active ? "#002045" : "transparent",
            color: active ? "#ffffff" : "#475569",
            fontWeight: 600,
            fontSize: "0.85rem",
            cursor: "pointer",
            transition: "background 0.15s, color 0.15s",
          }}
        >
          <i className={t.icon} />
          {t.label}
        </button>
      );
    })}
  </div>
);

export default ViewTabs;
